import { ApplicationPointOfSaleDecisions } from '@breathelife/types';

import ApiService from './ApiService';

export async function getPointOfSaleDecisions(applicationId: string): Promise<ApplicationPointOfSaleDecisions> {
  const response = await ApiService.getPointOfSaleDecisions(applicationId);
  return response.data;
}
